<template>
  <div class="flex flex-col h-screen font-body">
    <main class="flex-1 text-white bg-black overflow-y-auto">
      <slot />
    </main>
  </div>
</template>
